import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Observable, ReplaySubject} from 'rxjs';
import {Model} from '../../../../../domain/model/common/model.class';
import {AoaBoardService} from '../../../../../domain/model/licenses-certifications/board/aoa/aoa-board.service';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {AoaBoard} from '../../../../../domain/model/licenses-certifications/board/aoa/aoa-board.model';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FileLocation, FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {AoaBoardScreensManager} from './aoa-board-screens-manager.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import { VerificationService } from '../../../../../components/verification/service/verification.service';

@Component({
    template: require('./aoa-board-screen.component.html')
})
export class AoaBoardScreenComponent {

    constructor(readonly modelService: AoaBoardService,
                readonly route: ActivatedRoute,
                readonly screensManager: AoaBoardScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {}

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    certifications: Array<string> = [
        'American Osteopathic  Board of Anesthesiology',
        'American Osteopathic Board of Dermatology',
        'American Osteopathic Board of Emergency Medicine',
        'American Osteopathic Board of Family Physicians',
        'American Osteopathic Board of Internal Medicine',
        'American Osteopathic Board of Neurology & Psychiatry',
        'American Osteopathic Board of Neuromusculoskeletal Medicine',
        'American Osteopathic Board of Nuclear Medicine',
        'American Osteopathic Board of Obstetrics and Gynecology',
        'American Osteopathic Board of Ophthalmology and Otolaryngology- Head and neck surgery',
        'American Osteopathic Board of Orthopedic Surgery',
        'American Osteopathic Board of Pathology',
        'American Osteopathic Board of Pediatrics',
        'American Osteopathic Board of Physical Medicine and Rehabilitation',
        'American Osteopathic Board of Preventive Medicine',
        'American Osteopathic Board of Proctology',
        'American Osteopathic Board of Radiology',
        'American Osteopathic Board of Surgery'
    ];

    certificationDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    supportingDocumentFileLocation: FileLocation;

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<AoaBoard>({
        initialDataModel: new AoaBoard(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.supportingDocumentFileLocation = this.fileLocationFactory.create('aoaBoard', `currentUser/${this.index}`, new ProjectionInformation('supportingDocument'));
            this.verificationService.setUrl('aoaBoard', undefined, `${this.index}`);
            return this.modelService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: AoaBoard) => {
            return this.modelService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.index !== 1 ? this.modelService.doesCurrentUserModelEntryExist(this.index).map(r => !r) : Observable.of(false)
    });

    get model(): AoaBoard {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleCurrentlyCertifiedChange() {
        if (!this.model.currentlyCertified) this.model.certificationDate = undefined;
    }

    handleRecertifiedChange() {
        if (!this.model.recertified) this.model.recertificationDate = undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/aoa/aoa-board-screen.component.ts